import { Injectable, Signal, inject } from '@angular/core';
import { APP_ACTIONS, type AppActionsApi } from '@app/core/app.actions';
import { RxState } from '@rx-angular/state';
import { Bunker } from '@vessel-reports/port/state/port.types';
import { Detail } from '@vessel-reports/rob/state/rob.types';

interface IRobState {
  detailReport: any;
  previousReport: any;
  inventories: any[];
  detailBunker: Bunker;
  types: any[];
  voyages: any[];
  dateReport: any;
  ports: any[];
  selectedDetail: Detail;
  years: any[];
}

@Injectable({
  providedIn: 'root'
})
export class RobState extends RxState<IRobState> {
  protected readonly appActions: AppActionsApi = inject(APP_ACTIONS);

  detailReport: Signal<any> = this.signal('detailReport');
  previousReport: Signal<any> = this.signal('previousReport');
  detailBunker: Signal<Bunker> = this.signal('detailBunker');
  types: Signal<any> = this.signal('types');
  voyages: Signal<any> = this.signal('voyages');
  dateReport: Signal<any> = this.signal('dateReport');
  ports: Signal<any> = this.signal('ports');
  inventories: Signal<any> = this.signal('inventories');
  selectedDetail: Signal<Detail> = this.signal('selectedDetail');
  years: Signal<any[]> = this.signal('years');

  constructor() {
    super();
    this.hold(this.appActions.resetAll$, () => {
      this.reset();
    });
    this.set({
      detailReport: null,
      previousReport: null,
      inventories: [],
      detailBunker: null,
      ports: [],
      selectedDetail: null,
      dateReport: null,
      years: []
    });
  }

  // Clear all ROB related state
  reset(): void {
    this.set({
      detailReport: null,
      previousReport: null,
      inventories: [],
      detailBunker: null,
      types: [],
      voyages: [],
      dateReport: null,
      ports: [],
      selectedDetail: null,
      years: []
    });
  }
}
